// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"17d8b3a4","605":"ae77432c","809":"62452d41","981":"4fe1057f"}[chunkId] + ".chunk.js";
};